import React from "react";
import { Popover } from "antd";
import { getAnalyticsHelp } from "./analyticsHelpContent";

const stopPanelClick = (e) => {
  e.stopPropagation();
};

const AnalyticsHelpIcon = ({ helpKey, text, placement = "top", className = "" }) => {
  const content = text || getAnalyticsHelp(helpKey);
  if (!content) return null;

  return (
    <Popover
      content={<p className="analytics-help-popover__text">{content}</p>}
      trigger="hover"
      placement={placement}
      overlayClassName="analytics-help-popover"
      mouseEnterDelay={0.15}
      mouseLeaveDelay={0.08}
      zIndex={1100}
      getPopupContainer={() => document.body}
    >
      <span
        role="button"
        tabIndex={0}
        className={`analytics-help-icon ${className}`.trim()}
        aria-label="What does this mean?"
        onClick={stopPanelClick}
        onMouseDown={stopPanelClick}
        onKeyDown={(e) => {
          stopPanelClick(e);
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
          }
        }}
      >
        <i className="fa-solid fa-circle-question" aria-hidden="true" />
      </span>
    </Popover>
  );
};

export default AnalyticsHelpIcon;
